export default __webpack_public_path__ + "images/auto-op-brug7f17e6b0ead709773c2619f8e915526d.svg";